import NextImage from 'next/image';
import NextLink from 'next/link';
import styled from 'styled-components';
import { FrostedGlassLight } from '@seed-health/tokens';
import { mqLargeMin, mqXLargeMin } from 'styled/tools/media-queries';

// QUIZ CARD
export const bgImg =
  'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1758034462/npd/1772635ea6ffdfde99cfe2a35498de31e0480971.png';

export const Parent = styled.div`
  margin-top: -108px; // 92 height + 16 padding;
  padding: 0 var(--radius--medium, 16px);
  position: relative;

  @media ${mqLargeMin} {
    margin-top: 0;
    padding: 0;
    min-width: 300px;
  }

  @media ${mqXLargeMin} {
    min-width: 340px;
  }
`;
export const Body = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 92px;
  border-radius: var(--radius--medium, 16px);
  background: var(--fill-brand);
  padding: var(--radius--small, 8px);

  @media ${mqLargeMin} {
    max-width: 360px;
    height: 100%;
    background-image: url(${bgImg});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: var(--radius--large, 32px);
    padding: var(--radius--medium, 16px);
    margin: 0;
    justify-content: center;
    align-items: flex-end;
  }
`;

export const MobileImage = styled(NextImage)`
  position: relative !important; // styled values take backseat to intrinsic next js values
  width: 116px !important;
  height: 100%;
  object-fit: cover;
  border-radius: var(--radius--small, 8px);

  @media ${mqLargeMin} {
    display: none;
  }
`;

export const Text = styled.div`
  padding: var(--radius--small, 8px);
  border-radius: var(--radius--medium, 16px);
  background-color: var(--fill-brand);
  color: var(--fill-primary);

  @media ${mqLargeMin} {
    border-radius: var(--radius--medium, 16px);
    background: var(--color-primary-snow-white-20, rgba(252, 252, 247, 0.2));
    backdrop-filter: ${FrostedGlassLight};
    -webkit-backdrop-filter: ${FrostedGlassLight};
    padding: var(--radius--medium, 16px);
  }
`;

export const Link = styled(NextLink)`
  color: var(--fill-primary);
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.16px;

  &:hover,
  &:focus {
    color: var(--fill-primary);
  }
`;
